import { Card } from '../card/Card';
import { Button } from '../button/Button';
import styles from './Form.module.css';

type FormProps = {
  title?: string;
  subtitle?: string;
  onSubmit: React.FormEventHandler<HTMLFormElement>;
  submitLabel: string;
  disabled?: boolean;
  loading?: boolean;
  children: React.ReactNode;
};

export function Form({
  title,
  subtitle,
  onSubmit,
  children,
  disabled,
  loading,
  submitLabel,
}: FormProps) {
  return (
    <Card title={title} subtitle={subtitle}>
      <form onSubmit={onSubmit} className={styles.form}>
        <div className={styles.group}>{children}</div>
        <div>
          <Button type="submit" disabled={disabled || loading}>
            {loading ? <span className={styles.spinner} /> : submitLabel}
          </Button>
        </div>
      </form>
    </Card>
  );
}
